module.exports = __webpack_public_path__ + "assets/src/style/img/svg/icons/category-community-organized.svg?02df8a350b4659ec01ad1caddc2b3a8c";